export const ErrorType = {
  tittleEmptyError: 'Title should not be empty',
  loadError: 'Unable to load todos',
  addError: 'Unable to add a todo',
  deleteError: 'Unable to delete a todo',
  updateError: 'Unable to update a todo',
  clearComplitedError: 'Unable to clear completed todos',
};
